import { render } from "./RolesData.vue?vue&type=template&id=5ea7e390"
import script from "./RolesData.vue?vue&type=script&lang=js"
export * from "./RolesData.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__